const type = 'SET_TIMELINE_EVENTS_LOADING';

const setTimelineEventsLoading = (data) => ({
  data,
  type,
});

export { type };
export default setTimelineEventsLoading;
